import { COLORS } from "layouts/ThemeProvider/palette";

export default {
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        borderRadius: 5,
        "&.Mui-error": {
          "& input": {
            backgroundColor: COLORS.melon,
            color: COLORS.radicalRed,
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: COLORS.flamingo,
          },
        },
      },
      input: {
        padding: "10px 9px",
        height: 30,
        border: "none",
        color: COLORS.havelockBlue,
        fontSize: 15,
        "&:placeholder-shown": {
          background: COLORS.polar,
        },
        "@media (min-width: 780px)": {
          padding: "10px 16px",
          fontSize: 17,
        },
      },
      notchedOutline: {
        borderWidth: 2,
        borderColor: COLORS.turquoise,
      },
      multiline: {
        background: COLORS.polar,
        "&.Mui-error": {
          backgroundColor: COLORS.melon,
        },
      },
      inputMultiline: {
        height: "auto",
        resize: "none",
        background: COLORS.polar,
      },
    },
  },
};
